export default __webpack_public_path__ + "d1a86e823972729d9fa31987a08550c8.png";